document.addEventListener('DOMContentLoaded', function () {
    const cartDrawer = document.getElementById('cart-drawer');
    const cartItemsContainer = document.getElementById('cart-items');
    const cartTotal = document.getElementById('cart-total');

    document.addEventListener('click', async function (event) {
        if (event.target.matches('.cart-drawer__close')) {
            closeCartDrawer();
        } else if (event.target.matches('.add-to-cart--submit')) {
            event.preventDefault();
            const form = event.target.closest('form');
            const formData = new FormData(form);
            await addToCart(formData);
            openCartDrawer();
        } else if (event.target.closest('.cart')) {
            openCartDrawer();
        } else if (event.target.matches('.cart-drawer__item-remove')) {
            const line = event.target.dataset.line;
            await updateCart(line, 0);
        }
    });

    cartItemsContainer.addEventListener('change', function (event) {
        if (event.target.matches('.cart-drawer__item-quantity')) {
            const line = event.target.dataset.line;
            const quantity = parseInt(event.target.value, 10);
            updateCart(line, quantity);
        }
    });

    function openCartDrawer() {
        // Check if the current page is not the cart page
        if (!window.location.pathname.includes('/cart')) {
            cartDrawer.classList.add('open');
            fetchCart();
        }
    }

    function closeCartDrawer() {
        cartDrawer.classList.remove('open');
    }

    function fetchCart() {
        fetch('/cart.js')
            .then(response => response.json())
            .then(data => {
                renderCartItems(data.items);
                cartTotal.textContent = formatMoney(data.total_price);
                updateCartQuantities(data.item_count);
            });
    }

    function renderCartItems(items) {
        cartItemsContainer.innerHTML = '';
        if (Array.isArray(items)) {
            items.forEach((item, index) => {
                const cartItem = document.createElement('div');
                cartItem.classList.add('cart-drawer__item');
                cartItem.innerHTML = `
                    <img src="${item.image}" alt="${item.title}">
                    <div class="cart-drawer__item-details">
                        <h3>${item.title}</h3>
                        <p>Price: ${formatMoney(item.price)}</p>
                    </div>
                    <div class="cart-drawer__item-controls">
                        <input type="number" class="cart-drawer__item-quantity" data-line="${index + 1}" value="${item.quantity}" min="1">
                        <button type="button" class="cart-drawer__item-remove" data-line="${index + 1}">&times;</button>
                    </div>
                `;
                cartItemsContainer.appendChild(cartItem);
            });
        }
    }

    function updateCart(line, quantity) {
        return fetch('/cart/change.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            body: JSON.stringify({ line: line, quantity: quantity })
        })
            .then(response => response.json())
            .then(data => {
                renderCartItems(data.items);
                cartTotal.textContent = formatMoney(data.total_price);
                updateCartQuantities(data.item_count);
            });
    }

    function addToCart(formData) {
        return fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            body: JSON.stringify(Object.fromEntries(formData))
        })
            .then(response => response.json())
            .then(data => {
                fetchCart();
            });
    }

    function updateCartQuantities(itemCount) {
        const cartQuantities = document.querySelectorAll('.cart-quantity');
        cartQuantities.forEach(cartQuantity => {
            cartQuantity.textContent = itemCount; // update cart quantity
        });
    }

    // Function to format money
    function formatMoney(cents, format = '{{amount}}') {
        if (typeof cents === 'string') cents = cents.replace('.', '');
        var value = '';
        var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
        function defaultOption(opt, def) {
            return (typeof opt === 'undefined' ? def : opt);
        }
        function formatWithDelimiters(number, precision, thousands, decimal) {
            precision = defaultOption(precision, 2);
            thousands = defaultOption(thousands, ',');
            decimal = defaultOption(decimal, '.');
            if (isNaN(number) || number == null) {
                return 0;
            }
            number = (number / 100.0).toFixed(precision);
            var parts = number.split('.');
            var dollarsAmount = parts[0].replace(
                /(\d)(?=(\d\d\d)+(?!\d))/g,
                '$1' + thousands
            );
            var centsAmount = parts[1] ? decimal + parts[1] : '';
            return dollarsAmount + centsAmount;
        }
        switch (format.match(placeholderRegex)[1]) {
            case 'amount':
                value = formatWithDelimiters(cents, 2);
                break;
            case 'amount_no_decimals':
                value = formatWithDelimiters(cents, 0);
                break;
            case 'amount_with_comma_separator':
                value = formatWithDelimiters(cents, 2, '.', ',');
                break;
            case 'amount_no_decimals_with_comma_separator':
                value = formatWithDelimiters(cents, 0, '.', ',');
                break;
        }
        return Shopify.currency.active + " " + format.replace(placeholderRegex, value);
    }
});